import type { NameOrIdKey } from "~/components/KeyAccessProvider/types";

export const useKeyedItemAccessForConfigurationAsCode = (): NameOrIdKey => {
    return "Id";
};

export default useKeyedItemAccessForConfigurationAsCode;
